import Container from './styled/Container'

const DropdownIcon = Container

export default DropdownIcon
